import React from 'react';

/**
 * The RudderStack quarter-sail mark —
 * the product logo shape, used in the chat's empty state (muted) and the turn
 * signature (brand blue). `currentColor` so the parent picks the tint.
 */
export const RudderstackMark: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M33.8954 6H6.10263C6.10263 20.7841 17.6125 33.0129 32.3695 33.9075L33.8954 34V6Z"
      fill="currentColor"
    />
  </svg>
);
